import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c(VContainer,{staticClass:"fullpage d-flex"},[_c(VRow,{attrs:{"align":"center","justify":"center","no-gutters":""}},[_c(VCol,{attrs:{"cols":"12","lg":"6"}},[_c('p',{staticClass:"text-h2 text-lg-h1"},[_vm._v(_vm._s(_vm.$t('us.title')))]),_c('br'),_c('p',[_vm._v(_vm._s(_vm.$t('us.p')))])])],1)],1),_c('Espa')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }